import React, { useMemo } from 'react';
import { Shape } from 'three';

// Native XR surfaces cannot use CSS. Keep this palette aligned with --gx-* dark tokens.
export const vrColors = { panel: '#101c2a', border: '#334454', card: '#203142', hover: '#30485d', text: '#f2f6fa', muted: '#a3b4c4', teal: '#00c2b3' };
export const noRaycast = () => null;
export function roundedRect(w: number, h: number, r = .018) {
  const s = new Shape();
  const x = -w / 2, y = -h / 2;
  s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
  s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
  s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y);
  return s;
}
export function Surface({ width, height, color, z = 0, r }: { width: number; height: number; color: string; z?: number; r?: number }) {
  const shape = useMemo(() => roundedRect(width, height, r), [width, height, r]);
  return <mesh position={[0, 0, z]}><shapeGeometry args={[shape]} /><meshBasicMaterial color={color} toneMapped={false} /></mesh>;
}
